import { FormsService } from "../../../services/forms/forms.service";
import { CreatePromoCodeActionType } from "../types";

export function* createPromoCodeSaga({ payload }: CreatePromoCodeActionType) {
    try {
        const { allPromoCodes, ...rest } = payload;
        const {
            data: { data: response },
        } = yield FormsService.createPaymentPromoCode(rest);

        window.handleChange({ id: "payment.promocodes", value: [...allPromoCodes, response] });
    } catch (error) {
        // yield put(Handle Error);
    }
}
